import script from "./popover.vue?vue&type=script&setup=true&lang=ts"
export * from "./popover.vue?vue&type=script&setup=true&lang=ts"

import "./popover.vue?vue&type=style&index=0&id=2a696be9&lang=scss"

const __exports__ = script;

export default __exports__